import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { PLATFORM_BILLING_REPOSITORY } from '../domain/repositories/platform-billing.repository';
import { PlatformBillingRemoteDatasource } from './datasources/remote/platform-billing.remote-datasource';
import { PlatformBillingMapper } from './mappers/platform-billing.mapper';
import { PlatformBillingRepositoryImpl } from './repositories/platform-billing.repository.impl';

export function providePlatformBillingData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    PlatformBillingRemoteDatasource,
    PlatformBillingMapper,
    { provide: PLATFORM_BILLING_REPOSITORY, useClass: PlatformBillingRepositoryImpl },
  ]);
}
